import React, {memo, useReducer, useRef} from 'react';
import {Space} from '@redlink/components/atoms';
import {TextInput, Button} from '@redlink/components/molecules';
import {useLocale} from '@redlink/assets/locale';
import {useValues} from '@redlink/assets/values';
import {useMutation, signInQuery} from '@redlink/services';
import {initialState, reducer, types} from './store';
import {AuthPageContainer} from './authPageContainer';

export const LoginPage = memo(({navigation}) => {
    const {dictionary} = useLocale();
    const {routes} = useValues();
    const authContainerRef = useRef(null);

    const [{username, password}, dispatch] = useReducer(reducer, initialState);

    const [signIn, {loading: signInIsBusy}] = useMutation(signInQuery, {
        done: async ({SignIn}) => {
            await authContainerRef.current.onAuthSuccess(SignIn);
        },
    });

    return (
        <AuthPageContainer
            ref={authContainerRef}
            isBusy={signInIsBusy}
            onRegisterPress={() => {
                navigation.navigate(routes.register.key);
            }}
            onLoginPress={() => {
                signIn({
                    username,
                    password,
                });
            }}
        >
            <TextInput
                require
                value={username}
                onChangeText={(value) =>
                    dispatch({type: types.SET_USERNAME, payload: value})
                }
                title={dictionary.email}
                keyboardType="email-address"
            />
            <Space size={16}/>
            <TextInput
                require
                value={password}
                onChangeText={(value) =>
                    dispatch({type: types.SET_PASSWORD, payload: value})
                }
                title={dictionary.password}
                secureTextEntry
            />
            <Space size={8}/>
            <Button variant="link" title={dictionary.forgetYourPassword}/>
        </AuthPageContainer>
    );
});
